import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SalonPublicThemeProvider } from '../../context/SalonPublicThemeContext';
import { useSalonsRetrieveQuery } from '../../services/salonsApi';


const SalonPublicThemeRoute = ({ children }) => {
  const { salonId } = useParams();
  const { i18n } = useTranslation();
  const { data } = useSalonsRetrieveQuery({
    salonId: Number(salonId),
    language: i18n.language,
  });

  return (
    <SalonPublicThemeProvider
      config={data?.public_theme}
      layoutConfig={data?.public_layout}
      templateKey={data?.public_template_key}
    >
      {children}
    </SalonPublicThemeProvider>
  );
};

export default SalonPublicThemeRoute;
